module.exports = __webpack_public_path__ + "static/media/product-DigitalCredit.3b58be64.png";